import {z} from 'zod';

/**
 * Schema for getting public download URL from storage service
 */
export const storagePublicUrlRequestSchema = z.object({
  namespace: z.string(),
  filename: z.string().optional(),
  variantId: z.string().optional(),
  expirationSeconds: z.number().optional(),
});

export type StoragePublicUrlRequest = z.infer<typeof storagePublicUrlRequestSchema>;
